import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import uuidv4 from 'uuid'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'

Vue.use(VueAxios, axios);
// SERVIDOR DE DESARROLLO
axios.defaults.baseURL = process.env.VUE_APP_API_URL

Vue.config.productionTip = false



new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
